// import React from "react";
// import {
//   Modal,
//   ModalHeader,
//   ModalBody,
//   Row,
//   Col,
//   Table,
//   Badge,
// } from "reactstrap";

// const ViewCreditNoteModal = ({ show, toggle, creditNote }) => {
//   if (!creditNote) return null;

//   const {
//     creditNoteNo,
//     creditNoteDate,
//     sessionName,
//     taxName,
//     taxPerc,
//     taxPerCgst,
//     taxPerSgst,
//     invoiceNo,
//     invoiceDate,
//     invoiceAmount,
//     customerName,
//     customerAddress,
//     customerGSTNo,
//     customerPanNo,
//     customerState,
//     creditNoteAmount,
//     cgst,
//     sgst,
//     igst,
//     totalGst,
//     grandTotal,
//     note,
//     billInvoiceResponses,
//   } = creditNote;

//   return (
//     <Modal isOpen={show} toggle={toggle} size="lg" centered>
//       <ModalHeader toggle={toggle}>Credit Note — {creditNoteNo}</ModalHeader>

//       <ModalBody>
//         {/* Top summary */}
//         <Row className="mb-3">
//           <Col md={4}>
//             <div className="text-muted small">Credit Note Date</div>
//             <div className="fw-semibold">{creditNoteDate || "-"}</div>
//           </Col>
//           <Col md={4}>
//             <div className="text-muted small">Session</div>
//             <div className="fw-semibold">{sessionName || "-"}</div>
//           </Col>
//           <Col md={4}>
//             <div className="text-muted small">Against Invoice</div>
//             <div className="fw-semibold">
//               {invoiceNo || "-"}{" "}
//               {invoiceDate && (
//                 <span className="text-muted">({invoiceDate})</span>
//               )}
//             </div>
//           </Col>
//         </Row>

//         {/* Customer details */}
//         <div className="border rounded p-3 mb-3">
//           <h6 className="mb-2">Customer Details</h6>
//           <Row>
//             <Col md={6}>
//               <div className="text-muted small">Name</div>
//               <div className="fw-semibold">{customerName || "-"}</div>
//             </Col>
//             <Col md={6}>
//               <div className="text-muted small">GST No</div>
//               <div className="fw-semibold">{customerGSTNo || "-"}</div>
//             </Col>
//             <Col md={6} className="mt-2">
//               <div className="text-muted small">PAN No</div>
//               <div className="fw-semibold">{customerPanNo || "-"}</div>
//             </Col>
//             <Col md={6} className="mt-2">
//               <div className="text-muted small">State</div>
//               <div className="fw-semibold">{customerState || "-"}</div>
//             </Col>
//             <Col md={12} className="mt-2">
//               <div className="text-muted small">Address</div>
//               <div className="fw-semibold">{customerAddress || "-"}</div>
//             </Col>
//           </Row>
//         </div>

//         {/* Trip / invoice line items */}
//         {billInvoiceResponses?.length > 0 && (
//           <div className="mb-3">
//             <h6 className="mb-2">Invoice Trip Details</h6>
//             <div className="table-responsive">
//               <Table bordered size="sm">
//                 <thead className="table-light">
//                   <tr>
//                     <th>Trip No</th>
//                     <th>Trip Date</th>
//                     <th>Vehicle No</th>
//                     <th>Supplier</th>
//                     <th>Type</th>
//                     <th>KM/Trip</th>
//                     <th>Rate</th>
//                     <th>Amount</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {billInvoiceResponses.map((trip) => (
//                     <tr key={trip.id}>
//                       <td>{trip.tripNo}</td>
//                       <td>{trip.tripDate}</td>
//                       <td>{trip.vehicleNo}</td>
//                       <td>{trip.suppliersName}</td>
//                       <td>{trip.partyType}</td>
//                       <td>{trip.kmOrTrip}</td>
//                       <td>{trip.rate}</td>
//                       <td>{trip.amount}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </Table>
//             </div>
//           </div>
//         )}

//         {/* Amount summary */}
//         <div className="border rounded p-3 mb-3">
//           <h6 className="mb-2">Credit Note Summary</h6>
//           <div className="table-responsive">
//             <Table bordered size="sm" className="mb-0">
//               <thead className="table-light">
//                 <tr>
//                   <th>Invoice Amount</th>
//                   <th>Taxable Amount</th>
//                   <th>CGST ({taxPerCgst || 0}%)</th>
//                   <th>SGST ({taxPerSgst || 0}%)</th>
//                   <th>Total GST</th>
//                   <th>Grand Total</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 <tr>
//                   <td>₹ {Number(invoiceAmount || 0).toFixed(2)}</td>
//                   <td>₹ {Number(creditNoteAmount || 0).toFixed(2)}</td>
//                   <td>₹ {Number(cgst || 0).toFixed(2)}</td>
//                   <td>₹ {Number(sgst || 0).toFixed(2)}</td>
//                   <td>
//                     <b>₹ {Number(totalGst || 0).toFixed(2)}</b>
//                   </td>
//                   <td>
//                     <b>₹ {Number(grandTotal || 0).toFixed(2)}</b>
//                   </td>
//                 </tr>
//               </tbody>
//             </Table>
//           </div>
//         </div>

//         {/* Note */}
//         {note ? (
//           <div>
//             <div className="text-muted small">Note</div>
//             <div className="fw-semibold">{note}</div>
//           </div>
//         ) : null}
//       </ModalBody>
//     </Modal>
//   );
// };

// export default ViewCreditNoteModal;

import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Col,
  Table,
  Badge,
} from "reactstrap";

const ViewCreditNoteModal = ({ show, toggle, creditNote }) => {
  if (!creditNote) return null;

  const {
    creditNoteNo,
    creditNoteDate,
    sessionName,
    taxName,
    taxPerc,
    taxPerCgst,
    taxPerSgst,
    invoiceNo,
    invoiceDate,
    invoiceAmount,
    customerName,
    customerAddress,
    customerGSTNo,
    customerPanNo,
    customerState,
    creditNoteAmount,
    cgst,
    sgst,
    igst,
    totalGst,
    grandTotal,
    tollCharges,
    otherCharges,
    handlingCharges,
    note,
    billInvoiceResponses,
  } = creditNote;

  return (
    <Modal isOpen={show} toggle={toggle} size="lg" centered>
      <ModalHeader toggle={toggle}>Credit Note — {creditNoteNo}</ModalHeader>

      <ModalBody>
        {/* Top summary */}
        <Row className="mb-3">
          <Col md={4}>
            <div className="text-muted small">Credit Note Date</div>
            <div className="fw-semibold">{creditNoteDate || "-"}</div>
          </Col>
          <Col md={4}>
            <div className="text-muted small">Session</div>
            <div className="fw-semibold">{sessionName || "-"}</div>
          </Col>
          <Col md={4}>
            <div className="text-muted small">Against Invoice</div>
            <div className="fw-semibold">
              {invoiceNo || "-"}{" "}
              {invoiceDate && (
                <span className="text-muted">({invoiceDate})</span>
              )}
            </div>
          </Col>
        </Row>

        {/* Customer details */}
        <div className="border rounded p-3 mb-3">
          <h6 className="mb-2">Customer Details</h6>
          <Row>
            <Col md={6}>
              <div className="text-muted small">Name</div>
              <div className="fw-semibold">{customerName || "-"}</div>
            </Col>
            <Col md={6}>
              <div className="text-muted small">GST No</div>
              <div className="fw-semibold">{customerGSTNo || "-"}</div>
            </Col>
            <Col md={6} className="mt-2">
              <div className="text-muted small">PAN No</div>
              <div className="fw-semibold">{customerPanNo || "-"}</div>
            </Col>
            <Col md={6} className="mt-2">
              <div className="text-muted small">State</div>
              <div className="fw-semibold">{customerState || "-"}</div>
            </Col>
            <Col md={12} className="mt-2">
              <div className="text-muted small">Address</div>
              <div className="fw-semibold">{customerAddress || "-"}</div>
            </Col>
          </Row>
        </div>

        {/* Trip / invoice line items */}
        {billInvoiceResponses?.length > 0 && (
          <div className="mb-3">
            <h6 className="mb-2">Invoice Trip Details</h6>
            <div className="table-responsive">
              <Table bordered size="sm">
                <thead className="table-light">
                  <tr>
                    <th>Trip No</th>
                    <th>Trip Date</th>
                    <th>Vehicle No</th>
                    <th>Supplier</th>
                    <th>Type</th>
                    <th>KM/Trip</th>
                    <th>Rate</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {billInvoiceResponses.map((trip) => (
                    <tr key={trip.id}>
                      <td>{trip.tripNo}</td>
                      <td>{trip.tripDate}</td>
                      <td>{trip.vehicleNo}</td>
                      <td>{trip.suppliersName}</td>
                      <td>{trip.partyType}</td>
                      <td>{trip.kmOrTrip}</td>
                      <td>{trip.rate}</td>
                      <td>{trip.amount}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        )}

        {/* Amount summary */}
        <div className="border rounded p-3 mb-3">
          <h6 className="mb-2">Credit Note Summary</h6>
          <div className="table-responsive">
            <Table bordered size="sm" className="mb-0">
              <thead className="table-light">
                <tr>
                  <th>Invoice Amount</th>
                  <th>Taxable Amount</th>
                  <th>Toll Charges</th>
                  <th>Other Charges</th>
                  <th>Handling Charges</th>
                  <th>CGST ({taxPerCgst || 0}%)</th>
                  <th>SGST ({taxPerSgst || 0}%)</th>
                  <th>Total GST</th>
                  <th>Grand Total</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>₹ {Number(invoiceAmount || 0).toFixed(2)}</td>
                  <td>₹ {Number(creditNoteAmount || 0).toFixed(2)}</td>
                  <td>₹ {Number(tollCharges || 0).toFixed(2)}</td>
                  <td>₹ {Number(otherCharges || 0).toFixed(2)}</td>
                  <td>₹ {Number(handlingCharges || 0).toFixed(2)}</td>
                  <td>₹ {Number(cgst || 0).toFixed(2)}</td>
                  <td>₹ {Number(sgst || 0).toFixed(2)}</td>
                  <td>
                    <b>₹ {Number(totalGst || 0).toFixed(2)}</b>
                  </td>
                  <td>
                    <b>₹ {Number(grandTotal || 0).toFixed(2)}</b>
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>

        {/* Note */}
        {note ? (
          <div>
            <div className="text-muted small">Note</div>
            <div className="fw-semibold">{note}</div>
          </div>
        ) : null}
      </ModalBody>
    </Modal>
  );
};

export default ViewCreditNoteModal;
